module.exports = __webpack_public_path__ + "static/media/night.b0d4794f.jpeg";